import React, { useState, useEffect } from 'react';
import '../styles/Dashboard.css';

function MyProfileModal({ isOpen, onClose, onSave, currentUser }) {
  const [formData, setFormData] = useState({
    name: ''
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setFormData({
        name: currentUser.name || ''
      });
    }
  }, [currentUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      alert('Please enter your name');
      return;
    }

    setSaving(true);
    try {
      await onSave({
        name: formData.name,
        notificationPreferences: currentUser.notificationPreferences
      });
      onClose();
    } catch (error) {
      alert('Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '540px' }}>
        <div className="modal-header">
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--ink)', margin: 0 }}>
            My Profile
          </h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={{ paddingTop: '24px' }}>
            <div className="form-group">
              <label className="form-label" htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
                required
              />
              <small className="form-helper">
                This name will appear when you email certificates to employers
              </small>
            </div>

            <div className="form-group" style={{ marginTop: '24px' }}>
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-input"
                value={currentUser?.email || ''}
                disabled
                style={{ 
                  background: 'var(--bg)', 
                  color: 'var(--muted)',
                  cursor: 'not-allowed'
                }}
              />
              <small className="form-helper">
                Email cannot be changed
              </small>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save Profile'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MyProfileModal;
